export async function requestLikeResource(id: number, type: ResourceType) {
  return http.post('/v1/like/like', {
    id,
    type
  })
}

export async function cancel(id: number, type: ResourceType) {
  return http.post('/v1/like/cancel', {
    id,
    type
  })
}

export async function dislike(id: number, type: ResourceType) {
  return http.post('/v1/like/dislike', {
    id,
    type
  })
}

export async function status(id: number, type: ResourceType) {
  return http.get<{
    status: LikeStatus
  }>('/v1/like/status', {
    id,
    type
  })
}
